import { useTranslation } from 'react-i18next'

import { ProgramDetailTable } from './Shared/ProgramDetailTable'
import { CountryComplianceCheck } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Flex, Typography } from '@percent/lemonade'

export function ProgramCountryComplianceDetails({ requiredRegulations }: Readonly<CountryComplianceCheck>) {
  const { t } = useTranslation()

  if (!requiredRegulations.length) return null

  return (
    <Flex gap={16} direction="column">
      <Typography variant="h4">{t('typography.countryCompliance')}</Typography>
      <ProgramDetailTable title={t('program.label.requiredRegulations')} items={requiredRegulations} />
    </Flex>
  )
}
